import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useDeepCompareEffect } from 'react-use'

import { jobInviteInvitesSentList } from 'features/job-invite/store'
import { NoDataTextMessage, OverlayDataShower, Pagination } from 'components/Elements'
import { Grid } from './Grid'
import { Filter } from './Filter'

const SentInvitesContainerComponent = ({ ...props }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      dispatch(jobInviteInvitesSentList.resetDataState({}))
    }
  }, [])

  useDeepCompareEffect(() => {
    fetchList()
  }, [props.page, props.filters])

  const fetchList = () => {
    let params = {
      page: props.page,
      filters: {
        ...props.filters,
        job: props.filters?.job?.id || null,
      },
      sort: [{ id: 'created_at', desc: true }],
    }

    dispatch(jobInviteInvitesSentList.getList({ params }))
  }

  const onPageChange = item => {
    dispatch(jobInviteInvitesSentList.setPage(item.selected + 1))
  }

  const onFiltersChange = values => {
    dispatch(jobInviteInvitesSentList.changeFilter({ ...values }))
  }

  const isLoading = useMemo(() => {
    return props.loading
  }, [props.loading])

  return (
    <>
      <h4 className="font-size-18">{t('candidate_invites')}</h4>

      <div className={'mb-2'}>
        <Filter defaultValues={props.filters} onFiltersChange={onFiltersChange} />
      </div>

      <OverlayDataShower isLoading={isLoading} isFailed={!!props.error} error={props.error}>
        <Grid items={props.list} />

        <Pagination data={props.meta} onPageChange={onPageChange} className={'mt-2'} />
      </OverlayDataShower>

      {!props.list.length && !props.loading && !props.error && (
        <NoDataTextMessage>{t('no_invites_yet')}</NoDataTextMessage>
      )}
    </>
  )
}

SentInvitesContainerComponent.propTypes = {}

const mapStateToProps = state => {
  const { list, loading, error, meta, page, filters } = state.jobInvite.invites.sent.list
  return {
    list,
    loading,
    error,
    meta,
    page,
    filters,
  }
}

export const SentInvitesContainer = connect(mapStateToProps)(SentInvitesContainerComponent)
